/**
 * Konstanten und Hilfsfunktionen für die Authentifizierung
 */

/**
 * Hinweis: localStorage statt sessionStorage, damit der Status über mehrere Tabs geteilt wird.
 */
// Schlüssel für die Authentifizierungsinformationen im localStorage
const BENUTZER_ANGEMELDET_KEY: string = 'istAngemeldet';

/**
 * Prüft, ob der Benutzer angemeldet ist
 * @returns {boolean} True, wenn der Benutzer angemeldet ist, sonst false
 */
export const istBenutzerAngemeldet = (): boolean => {
    return localStorage.getItem(BENUTZER_ANGEMELDET_KEY) === 'true';
};

/**
 * Setzt den Authentifizierungsstatus
 * @param {boolean} status - Der Authentifizierungsstatus
 */
export const setzeAnmeldestatus = (status: boolean): void => {
    if (status) {
        localStorage.setItem(BENUTZER_ANGEMELDET_KEY, 'true');
    } else {
        localStorage.removeItem(BENUTZER_ANGEMELDET_KEY);
    }
};

/**
 * Löscht den Authentifizierungsstatus
 */
export const loescheAnmeldestatus = (): void => {
    localStorage.removeItem(BENUTZER_ANGEMELDET_KEY);
};
